module.exports = __webpack_public_path__ + "static/media/delete_card.cbe5b823.gif";